export default "__VITE_ASSET__CqOLcOKG__"